import React from "react";

import { PaymentOrderStatus, PaymentStatus } from "../../../types/payment";
import { UserRole } from "../../../types/userCurrent";

import PaymentStatusBadge from "./PaymentStatusBadge";
import PreSubmitPaymentStatusBadge from "./PreSubmitPaymentStatusBadge";
import { ApproveStatus } from "../../../types/claim";

type PrePaymentStatusBadgeProps = {
    paymentOrderStatus: PaymentOrderStatus;
    paymentStatus?: PaymentStatus | null;
    showActionRequired?: boolean;
    roles?: UserRole[];
    approverStatus?: ApproveStatus;
    isPreviousPriorityApproverApproved?: boolean | null;
    isListView?: boolean;
};

const PreAndPaymentStatusBadge = ({
    roles,
    paymentOrderStatus,
    paymentStatus,
    showActionRequired,
    approverStatus,
    isPreviousPriorityApproverApproved,
    isListView,
}: PrePaymentStatusBadgeProps): JSX.Element => {
    if (
        paymentStatus &&
        paymentOrderStatus === PaymentOrderStatus.ALL_APPROVED
    ) {
        // Go here when payment action finished
        return (
            <PaymentStatusBadge
                paymentStatus={paymentStatus}
                roles={roles}
                isPaymentReceipt={!!isListView}
                showActionRequired={true}
            />
        );
    } else {
        return (
            <PreSubmitPaymentStatusBadge
                paymentOrderStatus={paymentOrderStatus}
                roles={roles}
                showActionRequired={showActionRequired}
                approverStatus={approverStatus}
                isPreviousPriorityApproverApproved={
                    isPreviousPriorityApproverApproved
                }
                isListView={!!isListView}
            />
        );
    }
};

export default PreAndPaymentStatusBadge;
